import React, { useState } from 'react';
import ReactPlayer from 'react-player/lazy';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useInView } from 'react-intersection-observer';

import { system100 } from 'Mui/styles/color';
import { stylePropType } from 'utils/propTypes';

import VideoPlayerFacebook from 'components/VideoPlayerFacebook';

const fbUrlRegexp = /facebook\.com|fb\.watch/i;

export default function VideoPlayer({ canStartLoading = true, enableLazyLoad, url, style }) {
    const [isReady, setIsReady] = useState(false);
    const isFbTypeUrl = fbUrlRegexp.test(url);
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '100px 0%',
        skip: !enableLazyLoad
    });

    return (
        <div ref={ref} css={[containerStyle, css(style)]}>
            {!isReady && <CircularProgress css={progressStyle} />}
            {canStartLoading && (!enableLazyLoad || inView) && (
                <>
                    {isFbTypeUrl ? (
                        <VideoPlayerFacebook url={url} onReady={() => setIsReady(true)} controls />
                    ) : (
                        <ReactPlayer
                            onReady={() => setIsReady(true)}
                            url={url}
                            width="100%"
                            height="100%"
                            controls
                        />
                    )}
                </>
            )}
        </div>
    );
}

VideoPlayer.propTypes = {
    url: PropTypes.string,
    style: stylePropType
};

const containerStyle = css`
    width: 100%;
    height: 100%;
    background-color: ${system100.color};
    position: relative;
`;

const progressStyle = css`
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;
